import {
  ReportTourDetailCommissionModel,
  ReportTourDetailOtherExpenseModel,
  ReportTourDetailOtherIncomeModel,
  ReportTourDetailPurchaseModel,
  ReportTourDetailSaleModel,
} from 'api-hooks/report/model';
import { string2money } from 'common/utils/string';
import { IColumn } from 'components/elements/table-component/table-component';
import useDate from 'hooks/use-date';

export const ReportTourDetailSaleColumn: ({
  t,
}) => IColumn<ReportTourDetailSaleModel>[] = ({ t }) => {
  const formatDate = useDate();
  return [
    {
      header: t('common:transaction_at'),
      accessorKey: 'transactionAt',
      minSize: 150,
      cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
    },
    {
      header: t('common:completed_at'),
      accessorKey: 'completedAt',
      minSize: 150,
      cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
    },
    {
      header: t('common:invoice_number'),
      accessorKey: 'number',
      minSize: 150,
    },
    {
      header: t('common:customer'),
      accessorKey: 'customer',
      minSize: 150,
    },
    {
      header: t('common:participant'),
      accessorKey: 'participants',
      minSize: 150,
    },
    {
      header: t('common:sale'),
      accessorKey: 'sales',
      minSize: 150,
      cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
    },
    {
      header: t('common:tipping'),
      accessorKey: 'tipping',
      minSize: 150,
      cell: ({ getValue }) => `Rp ${string2money((getValue() as number) || 0)}`,
    },
  ];
};

export const ReportTourDetailPurchaseColumn: ({
  t,
}) => IColumn<ReportTourDetailPurchaseModel>[] = ({ t }) => {
  const formatDate = useDate();
  return [
    {
      header: t('common:transaction_at'),
      accessorKey: 'transactionAt',
      minSize: 150,
      cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
    },
    {
      header: t('common:completed_at'),
      accessorKey: 'completedAt',
      minSize: 150,
      cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
    },
    {
      header: t('common:order_number'),
      accessorKey: 'number',
      minSize: 150,
    },
    {
      header: t('common:agent'),
      accessorKey: 'customer',
      minSize: 150,
    },
    {
      header: t('common:guest'),
      accessorKey: 'guests',
      minSize: 150,
    },
    {
      header: t('common:purchase'),
      accessorKey: 'purchase',
      minSize: 150,
      cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
    },
  ];
};

export const ReportTourDetailCommissionColumn: ({
  t,
}) => IColumn<ReportTourDetailCommissionModel>[] = ({ t }) => {
  return [
    {
      header: t('common:employee'),
      accessorKey: 'employee',
      minSize: 150,
    },
    {
      header: t('common:role'),
      accessorKey: 'role',
      minSize: 150,
    },
    {
      header: t('common:number_of_pax'),
      accessorKey: 'noOfPax',
      minSize: 150,
    },
    {
      header: t('common:commission_per_pax'),
      accessorKey: 'commissionPerPax',
      minSize: 150,
      cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
    },
    {
      header: t('common:total_commission'),
      accessorKey: 'totalCommission',
      minSize: 150,
      cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
    },
  ];
};

export const ReportTourDetailOtherExpenseColumns: ({
  t,
}) => IColumn<ReportTourDetailOtherExpenseModel>[] = ({ t }) => {
  const formatDate = useDate();
  return [
    {
      header: t('common:transaction_at'),
      accessorKey: 'transactionAt',
      minSize: 150,
      cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
    },

    {
      header: t('common:no'),
      accessorKey: 'number',
      minSize: 150,
    },
    {
      header: t('common:account_type'),
      accessorKey: 'accountType',
      minSize: 150,
    },
    {
      header: t('common:account'),
      accessorKey: 'account',
      minSize: 150,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 150,
    },
    {
      header: t('common:amount'),
      accessorKey: 'amount',
      minSize: 150,
      cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
    },
  ];
};

export const ReportTourDetailOtherIncomeColumns: ({
  t,
}) => IColumn<ReportTourDetailOtherIncomeModel>[] = ({ t }) => {
  const formatDate = useDate();
  return [
    {
      header: t('common:transaction_at'),
      accessorKey: 'transactionAt',
      minSize: 150,
      cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
    },
    {
      header: t('common:acknowledged_at'),
      accessorKey: 'acknowledgedAt',
      minSize: 150,
      cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
    },
    {
      header: t('common:no'),
      accessorKey: 'number',
      minSize: 150,
    },
    {
      header: t('common:account_type'),
      accessorKey: 'accountType',
      minSize: 150,
    },
    {
      header: t('common:account'),
      accessorKey: 'account',
      minSize: 150,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 150,
    },
    {
      header: t('common:amount'),
      accessorKey: 'amount',
      minSize: 150,
      cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
    },
  ];
};
